import { QueryClient } from '@tanstack/react-query';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import './config/i18n';
import App from './app/app';
import { NODE_ENV } from './config';
import { worker } from './mocks/browser';
import { rememberAccessToken } from './utils/agentsRequest';

if (NODE_ENV === 'local') {
    worker
        .start({
            onUnhandledRequest: 'warn',
        })
        .then(() => {
            console.log('[MSW] Worker iniciado');
        });
}

// Read token from URL before mounting to avoid race condition in useGetUserInfo
// Skip in test environments (Cypress injects window.Cypress)
if (!(window as Window & { Cypress?: unknown }).Cypress) {
    const urlParams = new URLSearchParams(globalThis.location.search);
    const urlToken = urlParams.get('token');
    if (urlToken) {
        rememberAccessToken(urlToken);
        const url = new URL(globalThis.location.href);
        url.searchParams.delete('token');
        globalThis.history.replaceState({}, '', url);
    }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
export const queryClient = new QueryClient();

(window as any).queryClientExposed = queryClient; // Expose queryClient globally for debugging

root.render(
    <StrictMode>
        <App queryClient={queryClient} />
    </StrictMode>,
);
